import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { FeatureFlags } from '@authe/fe-commons/flags';
import { jsx, Fragment } from 'react/jsx-runtime';
import { isProd } from '@authe/fe-commons/env';

var FlagsContext = React.createContext(null);
function FlagsProvider({ flags, children }) {
  return /* @__PURE__ */ jsx(FlagsContext.Provider, { value: flags, children });
}
function useFeatureFlags() {
  const flags = React.useContext(FlagsContext);
  return flags ?? EMPTY_FLAGS;
}
function useFeatureFlag(name) {
  return useFeatureFlags().isEnabled(name);
}
var EMPTY_FLAGS = new FeatureFlags();
function Flagged({ name, not = false, children, fallback = null }) {
  const enabled = useFeatureFlag(name);
  const show = not ? !enabled : enabled;
  return /* @__PURE__ */ jsx(Fragment, { children: show ? children : fallback });
}
function QaModeBanner({ env, show, className, children }) {
  const flags = useFeatureFlags();
  const blue = flags.isBlue();
  const nonProd = env ? !isProd(env) : false;
  const visible = show ?? (blue || nonProd);
  if (!visible) return null;
  const parts = [];
  if (env) parts.push(env.env.toUpperCase());
  if (blue) parts.push(`QA \xB7 ${flags.qaEnvironment()}`);
  const label = children ?? (parts.length ? `${parts.join(" \xB7 ")} environment` : "Non-production environment");
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "status",
      className: cn(
        "w-full bg-risk-medium/15 px-4 py-1 text-center text-xs font-medium text-risk-medium",
        className
      ),
      children: label
    }
  );
}

export { Flagged, FlagsProvider, QaModeBanner, useFeatureFlag, useFeatureFlags };
//# sourceMappingURL=chunk-3QIUEI63.js.map
//# sourceMappingURL=chunk-3QIUEI63.js.map